import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IListing } from '@out-web/core';
import { RouterLink } from '@angular/router';


@Component({
  selector: 'out-created-listing',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './created-listing.component.html',
  styleUrl: './created-listing.component.scss',
})
export class CreatedListingComponent {
  @Input() listingData: IListing | null | undefined = null;

  getFormattedDescription(): string {
    const description = this.listingData?.content?.description;
    return description ? description.replace(/\n<p>/g, '<br /><p>') : '';
  }
}
